module.exports = __webpack_public_path__ + "static/media/digitalmarketing.27398ad2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/digitalmarketing.jpg
// module id = 165
// module chunks = 0